export const PRODUCT_MASTER_LIST = 'PRODUCT_MASTER_LIST';
export const CREATE_PRODUCT_MASTER_SUCCESS = 'CREATE_PRODUCT_MASTER_SUCCESS';
export const DELETE_PRODUCT_MASTER_SUCCESS = 'DELETE_PRODUCT_MASTER_SUCCESS';
export const UPDATE_PRODUCT_MASTER_SUCCESS = 'UPDATE_PRODUCT_MASTER_SUCCESS';
export const PROPAGATE_PRODUCT_MASTER_SUCCESS = 'PROPAGATE_PRODUCT_MASTER_SUCCESS';
export const PRODUCT_SEARCH_LIST_UPDATE = 'PRODUCT_SEARCH_LIST_UPDATE';
export const PRODUCT_SEARCH_PROGRESS = 'PRODUCT_SEARCH_PROGRESS';
export const PRODUCT_SEARCH_LIST_CANCEL_TOKEN = 'PRODUCT_SEARCH_LIST_CANCEL_TOKEN';
export const PRODUCT_SEARCH_LIST_SUCCESS = 'PRODUCT_SEARCH_LIST_SUCCESS';
export const PRODUCT_SEARCH_CLEAR_LIST = 'PRODUCT_SEARCH_CLEAR_LIST';
